const SelectAutoComplete = ({list,callback})=>{
    const clickEvent =(e)=>{
        callback(e);
    }
    return (
        <div className="search-c__group" key={list.label}>
        {list.label && (
          <span className="search-c__group-heading">{list.label}</span>
        )}
        <ul className="search-c__menu-list">
          {list.options.map((suggestion, index) => {
            return (
              <li
                className="search-c__option"
                key={suggestion.label + index}
                onClick={clickEvent}
              >
                {suggestion.label}
              </li>
            );
          })}
        </ul>
      </div>
    )
}
export default  SelectAutoComplete